<template>
    <div>
        <div class="uk-modal-header">
            <h2>Reset My Password</h2>
        </div>
        <div class="modal-body">
            <form class="uk-form" role="form" @submit.prevent.stop="reset">
                <form-input
                    id="email"
                    v-model="email"
                    name="email"
                    type="email"
                    :error="has_error('email')"
                    :required="true"
                    placeholder="Email"
                    size="large"
                    width="1-1"
                    @input="update_email"
                />
                <form-input
                    id="password"
                    v-model="password"
                    name="password"
                    type="password"
                    :error="has_error('password')"
                    :required="true"
                    placeholder="Password"
                    size="large"
                    width="1-1"
                />
                <form-input
                    id="password_confirmation"
                    v-model="password_conf"
                    name="password_confirmation"
                    type="password"
                    :error="has_error('password_confirmation')"
                    :required="true"
                    placeholder="Confirm Password"
                    size="large"
                    width="1-1"
                />

                <div class="uk-text-center uk-margin-top">
                    <feedback-button
                        type="submit"
                        :status="feedback_status"
                        :waiting="loading"
                        :single-use="false"
                        color="primary"
                        @click.prevent="reset"
                    >
                        <template v-slot:message>
                            <div
                                :class="{ 'uk-text-danger': (feedback_status === false) }"
                            >
                                {{ feedback_message }}
                            </div>
                        </template>
                        Reset My Password
                    </feedback-button>
                </div>
            </form>
        </div>
        <div class="uk-modal-footer uk-text-center">
            <base-button
                flavor="link"
                size="small"
                class="uk-margin-top"
                @click.native.prevent="cancel"
            >
                Cancel and login instead
            </base-button>
        </div>
    </div>
</template>

<script>
import is_panel from "./IsPanel"

import FormInput from "../../ui/FormInput"
import FeedbackButton from "../../ui/FeedbackButton"
import BaseButton from "../../ui/BaseButton"

export default {
    mixins: [is_panel],
    components: {
        FormInput,
        FeedbackButton,
        BaseButton
    },
    methods: {
        reset () {
            setTimeout(() => {
                this.loading = true
                this.clear_all_errors()
                this.$store.dispatch("RESET_PASSWORD", {
                    token: this.$route.query["password-reset"],
                    email: this.email,
                    password: encodeURIComponent(this.password),
                    password_confirmation: encodeURIComponent(this.password_conf)
                }).then(response => {
                    this.$emit("input", "")
                    this.password = ""
                    this.password_conf = ""
                    this.cancel()
                }).catch(this.receive_error).then(() => {
                    this.loading = false
                })
            }, this.autofill_timeout) // need a timeout slightly longer than input field's debounce. Otherwise, Enter key happens before this.field is updated!
        },
        cancel () {
            window.location.search = ""
        }
    },
    data () {
        return {
            password: "",
            password_conf: "",
            handles_feedback: true
        }
    }
}
</script>
